module.exports = __webpack_public_path__ + "static/img/6.f2d9523.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/6.png
// module id = qHBX
// module chunks = 4